import { render, staticRenderFns } from "./List.vue?vue&type=template&id=2dd86913&"
import script from "./List.vue?vue&type=script&lang=babel&"
export * from "./List.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports